import { useState } from 'react';
import { lt, useUrlSyncedTableState } from '@mews/framework';
import { Table, TableProvider } from '@optimus-web/core';
import { LocalizedPageTitle, PortfolioLayoutHeader } from '@mews-commander/ui';
import { TextKey, ArticlePath, createGuideLink } from '@mews-commander/enums';
import { PortfolioCentralPaymentPolicyOverviewEntry } from '@mews-commander/data-access';
import { PaymentPoliciesSidePanel } from '../sidePanel';
import { useCentralPaymentPoliciesGetOverview } from '../../queries';
import { getPaymentPoliciesColumns } from './columns';
import { CreatePaymentPolicyButton } from './CreatePaymentPolicyButton';

export const PaymentPoliciesTable = () => {
    const [selectedPaymentPolicyId, setSelectedPaymentPolicyId] = useState<string>();

    const columns = getPaymentPoliciesColumns({
        onNameClick: (paymentPolicyId) => setSelectedPaymentPolicyId(paymentPolicyId),
    });

    const [tableState, setTableState] = useUrlSyncedTableState<PortfolioCentralPaymentPolicyOverviewEntry>({
        columns,
    });

    const { isFetching, data } = useCentralPaymentPoliciesGetOverview(tableState);

    return (
        <>
            <PortfolioLayoutHeader
                guideLink={createGuideLink(ArticlePath.HowToCreateMmpPaymentPolicy)}
                title={<LocalizedPageTitle textKey={TextKey.PaymentPolicyPlural} />}
                rightSide={<CreatePaymentPolicyButton />}
            />

            <TableProvider columns={columns} state={tableState} onStateChange={setTableState} as="div">
                <Table
                    amountOfRows={data?.totalRowCount ?? 0}
                    data={data?.data ?? []}
                    emptyState={{
                        primaryText: lt('PaymentPoliciesEmptyStateTitle'),
                        secondaryText: lt('PaymentPoliciesEmptyStateDescription'),
                        action: <CreatePaymentPolicyButton size="small" />,
                    }}
                    loading={isFetching}
                    uniqueRowId="id"
                />
            </TableProvider>

            <PaymentPoliciesSidePanel
                handleCloseSidePanel={() => setSelectedPaymentPolicyId(undefined)}
                paymentPolicyId={selectedPaymentPolicyId}
            />
        </>
    );
};
